import { API_BASE_URL, API_GET_USER_PROFILE } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export interface getUserProfileResponse {
    username: string;
    email: string;
    is_active: boolean;
    date_joined: string;
}

async function executeGetUserPrfileWithToken(accessToken: string | null): Promise<getUserProfileResponse> {
    return axios
        .get(
            API_BASE_URL + API_GET_USER_PROFILE,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else {
                console.error('Error during vote:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetUpvoteWithToken(accessToken: string | null): Promise<getUserProfileResponse> {

    return executeGetUserPrfileWithToken(accessToken)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetUserPrfileWithToken(refreshedAccessToken);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
